import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

import { ContratoService } from '../../../../../providers/contrato-service';
import { AlertService } from '../../../../../providers/alert-service';
import { MenuService } from '../../../../../providers/menu-service';
import { ModulosController } from '../../../modulos-controller';
import { UsuarioService } from '../../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../../providers/gestao-pca-service';
import { ProcessosCorrelatosPage } from '../../../processos-correlatos/processos-correlatos';

@Component({
  selector: 'page-resumo-relatorio-inspecao',
  templateUrl: 'resumo-relatorio-inspecao.html',
  providers: [
    ContratoService
  ]
})
export class ResumoRelatorioInspecaoPage extends ModulosController {
  listaDados: any;
  loading: boolean = true;
  submetendoNoCertificado: boolean = false;
  idSecaoPagina: string = "51";

  order: string = 'nrProcesso';
  reverse: boolean = true;

  constructor(public navCtrl: NavController,
    public alertService: AlertService,
    public modalCtrl: ModalController,
    public usuarioService: UsuarioService,
    public navParams: NavParams,
    public contratoService: ContratoService,
    public gestaoPcaService: GestaoPcaService,
    private menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
    this.carregarDados();

    this.setModuloId(5);
    this.setIdModuloPca(this.navParams.get('analise').idModuloPca);
  }

  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = false;
      this.order = "-" + value;
    } else {
      this.reverse = true;
      this.order = value;
    }
  }

  carregarDados() {
    this.contratoService.obterDadosResumoRelatorioInspecao().subscribe(data => {
      this.listaDados = data;
      this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.loading = false;
    });
  }

  formatarPorcentagem(valor) {
    return valor.toString().replace('.', ',') + "%";
  }

  voltar() {
    this.menuService.redirecionarPagina(this.contratoService.obterIdPaginaContrato());
  }

  salvarComentario() {
    this.loading = true;
    if (this.listaDados) {
      this.listaDados.resumoAnalise = this.capitalize(this.listaDados.resumoAnalise);
      this.contratoService.salvarDadosResumoRelatorioInspecao(this.listaDados, this.idSecaoPagina).subscribe(data => {
        this.alertService.mostraAlerta("", "Salvo com sucesso.");
        this.loading = false;
      }, error => {
        this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
        this.loading = false;
      });
    }
  }

  submeterNoCertificado() {
    this.loading = true;
    if (this.listaDados.resumoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.listaDados.resumoAnalise == null || this.listaDados.resumoAnalise == undefined || !this.listaDados.resumoAnalise) {
      this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
      this.loading = false;
    } else {
      if (this.listaDados) {

        var jsonSubmeter = {
          "idModuloAnalise": this.listaDados.idModuloAnalise,
          "dsResultadoAnalise": this.capitalize(this.listaDados.resumoAnalise)
        }

        this.contratoService.submeterAnalise(jsonSubmeter, this.idSecaoPagina).subscribe(data => {
          this.alertService.mostraAlerta("", "Submetido com sucesso.");
          this.voltar();
        }, error => {
          this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
          this.loading = false;
        });
      }
    }
  }

  baixarRelatorioCompleto(idDoc) {
    this.contratoService.obterArquivoResumoRelatorioInspecao(idDoc);
  }

  capitalize(str) {
    let retorno = "";

    if (str) {
      retorno = str.charAt(0).toUpperCase() + str.slice(1);
    }

    return retorno;
  }

  formatarProcesso(processo) {
    if (processo) {
      let a = processo.substr(0,4) + "/" + processo.substr(4,5) + "-" + processo.substr(9,1);
      return a; 
    }

    return "N/A";
  }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/contratos/contrato-analise/resumo-relatorio-inspecao/resumo-relatorio-inspecao.ts